// Helpers for reading fields out of a submission identifier.

// SubmissionIdentifier is "YYYY-NNNNNNNN" (see the API's counter MERGE), so the
// year is its first four characters.
//
// NOTE: this is the *calendar year the submission was filed*, which is only an
// approximation of the tax roll year. A submission period stays open until it is
// archived, so a period still open on Jan 1 mints identifiers under the next
// year and splits one filing period across two buckets. When the API grows a
// real TaxRollYear/SubmissionPeriodId on the submission, filter on that instead
// and delete this.
export function getSubmissionYear(submissionIdentifier) {
  return submissionIdentifier?.toString().substring(0, 4) || null;
}

// Distinct, non-empty years, newest first — the shape the Year Autocompletes want.
export function yearOptionsFrom(years) {
  const seen = new Set();
  for (const year of years) {
    if (year) seen.add(year);
  }
  return Array.from(seen).sort((a, b) => b.localeCompare(a));
}
